class CustomHeader extends HTMLElement {
  constructor() {
    super();
    this.previousIsDesktop = window.innerWidth > 940;
  }

  connectedCallback() {
    this.initHeader();
    this.initLanguageSelector();
  }

  initHeader() {
    const headerNormal = document.querySelector(".header-normal");
    const headerSticky = document.querySelector(".header-sticky");
    const headerSubCategories = document.querySelector(".collections-menu-container");
    const logoNormal = document.querySelector(".logo-normal");
    const cartMenuMobile = this.querySelector("#cart-icon-bubble-mobile");
    
    const cartDrawer = document.getElementById('cart-drawer');

    const menuBtn = document.querySelector('.nav__btn'); 
    const menuContent = document.querySelector('.nav__content'); 

    if (menuBtn && menuContent) {
      menuBtn.addEventListener('click', (event) => {
        event.preventDefault();
        menuContent.classList.toggle('active');
        menuBtn.classList.toggle('active');
      });

      const links = menuContent.querySelectorAll('a');
      links.forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const href = link.getAttribute('href');
          menuContent.classList.remove('active');
          menuBtn.classList.remove('active');
          menuContent.addEventListener('transitionend', () => {
            window.location.href = href;
          }, { once: true });
        });
      });
    }


    const fetchCartData= () => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          const headerSticky = document.querySelector('.header-sticky');
          const headerNormal = document.querySelector('.header-normal');
          if (data.item_count > 0) {
            headerSticky.querySelector('#cart-icon-bubble').textContent = window.translations.cart + " (" + data.item_count + ")";
            headerNormal.querySelector('#cart-icon-bubble').textContent = window.translations.cart + " (" + data.item_count + ")";
            cartMenuMobile.textContent = window.translations.cart + " (" + data.item_count + ")";
          } else {
            headerSticky.querySelector('#cart-icon-bubble').textContent = window.translations.cart;
            headerNormal.querySelector('#cart-icon-bubble').textContent = window.translations.cart;
            cartMenuMobile.textContent = window.translations.cart;
          }
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }

    // Configura el observer
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const currentClassList = mutation.target.classList;
          if (currentClassList.contains('show')) {
            fetchCartData();
          } else {
            fetchCartData();
          }
        }
      }
    });

    // Opciones de configuración para el observer
    const config = { attributes: true, attributeFilter: ['class'] };

    // Inicia la observación
    observer.observe(cartDrawer, config);

    cartMenuMobile.addEventListener("click", function (event) {
      if (menuContent && menuBtn) {
        menuContent.classList.remove('active'); 
        menuBtn.classList.remove('active'); 
      }
      fetchCartData(); 
    });
  

    const logoMobile = this.querySelector(".logo-mobile-img");

    const resetMenuStyles = () => {
      const isDesktop = window.innerWidth > 940;

      if (isDesktop && !this.previousIsDesktop) {
        logoMobile.style.display = "none";
        headerNormal.style.display = "block";
        headerSticky.style.display = "none";
        if (headerSubCategories) {
          headerSubCategories.style.top = "";
        }
      } else if (!isDesktop && this.previousIsDesktop) {
        headerNormal.style.display = "block";
        if (headerSubCategories) {
          headerSubCategories.style.top = "";
        }
        headerSubCategories.style.top = "";
        headerSticky.style.display = "none";
        logoMobile.style.display = "block";
      }

      this.previousIsDesktop = isDesktop;
    };

    window.addEventListener("resize", resetMenuStyles);
  
    const handleScroll = () => {
      const isDesktop = window.innerWidth > 940;

      if (isDesktop) {
        if (logoNormal) {
          const logoNormalHeight = logoNormal ? logoNormal.offsetHeight + 14 : 0;

          if (window.scrollY > logoNormalHeight) {
            headerSticky.style.display = "block";
            if (headerSubCategories) {
              headerSubCategories.classList.add("collections-menu-container-sticky");
            }
          } else {
            headerNormal.style.display = "block";
            headerSticky.style.display = "none";
            if (headerSubCategories) {
              headerSubCategories.classList.remove("collections-menu-container-sticky-mobile");
              headerSubCategories.classList.remove("collections-menu-container-sticky");
            }
          }
        }
      } else {
        headerNormal.style.display = "block";
        headerSticky.style.display = "none";
        if (headerSubCategories) {
          headerSubCategories.style.top = "0";
        }
        

        if (window.scrollY > window.document.querySelector(".custom-header").offsetHeight && headerSubCategories ) {
          headerSubCategories.classList.add("collections-menu-container-sticky-mobile");
        } else {
          if (headerSubCategories) {
            headerSubCategories.classList.remove("collections-menu-container-sticky");
            headerSubCategories.classList.remove("collections-menu-container-sticky-mobile");
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    handleScroll();
  }

  initLanguageSelector() {
    const languageButtons = document.querySelectorAll('.language-selector-button');
    
    languageButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const container = e.target.closest('.language-selector-container');
        const dropdown = container.querySelector('.language-selector');
        
        // Toggle aria-expanded
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
        
        // Toggle hidden class
        dropdown.classList.toggle('hidden');
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.language-selector-container')) {
        document.querySelectorAll('.language-selector').forEach(dropdown => {
          dropdown.classList.add('hidden');
        });
        document.querySelectorAll('.language-selector-button').forEach(button => {
          button.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }
}

customElements.define("custom-header", CustomHeader);
